(function () {
  if (window.nxInview) {
    window.nxInview.scan();
    return;
  }
  var root = document.documentElement;
  var motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  if (motionOk && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    root.classList.add('nx-js');
  }
  function scan() {
    var els = document.querySelectorAll('[data-nx-reveal]:not(.is-in)');
    Array.prototype.forEach.call(els, function (el) {
      if (io) io.observe(el);
      else el.classList.add('is-in');
    });
  }
  window.nxInview = { scan: scan };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
